var _circle, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2, _g, _circle3, _circle4, _g2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchPageError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5811_61232",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 250,
    height: 250
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 125,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5811_61232)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 125,
    fill: "#8CD1FC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.7422,
    y: 47.6553,
    width: 112.367,
    height: 152.026,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78.3008,
    y: 151.43,
    width: 87.2499,
    height: 6.60985,
    rx: 2.96121,
    fill: "#E8E8E8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 78.3008,
    y: 171.259,
    width: 87.2499,
    height: 6.60985,
    rx: 2.96121,
    fill: "#E8E8E8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 78.3008,
    y: 131.601,
    width: 87.2499,
    height: 6.60985,
    rx: 2.96121,
    fill: "#E8E8E8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 78.3008,
    y: 111.771,
    width: 87.2499,
    height: 6.60984,
    rx: 2.96121,
    fill: "#E8E8E8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 78.3008,
    y: 91.9414,
    width: 87.2499,
    height: 6.60985,
    rx: 2.96121,
    fill: "#E8E8E8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 78.3008,
    y: 72.1123,
    width: 87.2499,
    height: 6.60984,
    rx: 2.96121,
    fill: "#E8E8E8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 10.899,
    height: 20.241,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 137.426 125.929)",
    fill: "#FFC300"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.86 143.866C123.918 142.771 123.903 141.03 122.827 139.954L115.696 132.823C114.62 131.747 112.879 131.732 111.784 132.79L48.2491 194.189L61.4607 207.401L122.86 143.866Z",
    fill: "#00539D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5811_61232",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 132,
    width: 76,
    height: 76
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.86 143.866C123.918 142.771 123.903 141.03 122.827 139.954L115.696 132.823C114.62 131.747 112.879 131.732 111.784 132.79L48.2491 194.189L61.4607 207.401L122.86 143.866Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5811_61232)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 47.8778,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 162.201 92.9004)",
    fill: "#00539D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5811_61232",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 54,
    width: 78,
    height: 78
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 38.5357,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 162.201 92.9004)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5811_61232)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 38.5357,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 162.201 92.9004)",
    fill: "#29B8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 73.179,
    height: 121.446,
    transform: "matrix(-1 0 0 1 187.004 32.1973)",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.753 97.9643C165.753 98.6524 165.351 99.1685 164.606 99.1685H159.961C159.387 99.1685 158.871 98.7098 158.871 98.0789V93.5485C158.871 90.617 161.179 88.6651 163.311 86.862C165.142 85.3142 166.842 83.876 166.842 82.0218C166.842 79.9573 165.122 78.1795 162.255 78.1795C159.542 78.1795 158.002 79.5245 156.912 80.4761C156.596 80.7517 156.319 80.9942 156.061 81.1616C155.602 81.4483 155.201 81.4483 154.799 81.1042L152.104 78.4663C151.645 78.0648 151.703 77.3767 152.104 76.9752C152.104 76.9752 156.004 71.9287 163.344 71.9287C169.366 71.9287 174.47 75.943 174.47 81.563C174.47 85.6348 171.468 88.0083 168.988 89.9699C167.241 91.3512 165.753 92.5282 165.753 93.95V97.9643ZM166.613 108.918C166.613 111.269 164.606 113.219 162.255 113.219C159.903 113.219 158.011 111.269 158.011 108.918C158.011 106.624 159.903 104.617 162.255 104.617C164.606 104.617 166.613 106.624 166.613 108.918Z",
    fill: "#00559B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPageError);
export default __webpack_public_path__ + "static/media/search_page_error.55a543ab5647d761423a168a17f0e714.svg";
export { ForwardRef as ReactComponent };